<template>
<div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Edit Lead</strong>
          </div>
          <b-form-group
            label="Name"
            label-for="horizName"
            description="Please enter your name."
            :label-cols="3"
            :horizontal="true">
            <b-form-input id="horizName" type="text" placeholder="Enter Name.." v-model="item.name"></b-form-input>
          </b-form-group>
          <b-form-group
            label="Email"
            label-for="horizEmail"
            description="Please enter your email."
            :label-cols="3"
            :horizontal="true">
            <b-form-input id="horizEmail" type="email" placeholder="Enter Email.." v-model="item.email"></b-form-input>
          </b-form-group>          
          <div slot="footer">
            <b-form-group
              label=""
              :label-cols="3"
              :horizontal="true">
              <b-button type="submit" variant="primary" @click="cancel()">Submit</b-button>
              <b-button type="button" variant="secondary" @click="cancel()">Cancel</b-button>
            </b-form-group>
          </div>
        </b-card>
    </b-col>
  </b-row>
</div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'leadedit',
    props: {
    },
    data: () => {
      return {
        item: {},
        errors: [],
        fields: [
          {key: 'name'},
          {key: 'email'},
          {key: 'status'}
        ]
      }
    },
    mounted () {
      this.getItem(this.$route.params.id)
    },
    methods: {
      getItem (id) {
        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
        axios.defaults.headers.common['Accept'] = 'application/json'
        let accessToken = localStorage.getItem('access_token')

        if (accessToken !== null && accessToken !== '') {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken
        }

        let uri = window.apiUri + 'leads/' + id
        axios.get(uri)
          .then(response => {
            // JSON responses are automatically parsed.
            this.item = response.data.data
          })
          .catch(error => {
            // Wu oh! Something went wrong
            console.log(error.response.data)
            this.errors.push(error.response.data)
          })
      },
      cancel () {
        this.$router.push('/leads')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/LeadEdit.vue